/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { BsCheckCircleFill } from "react-icons/bs";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard Materail-UI example components
import Table from "examples/Tables/Table";

// Data
import data from "layouts/rtl/components/Projects/data";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { apiList } from "../../../../variables/api";
import { setDirection } from "../../../../context";
import { Pagination } from "@mui/material";
import * as querystring from "querystring";
import Box from "@mui/material/Box";
import { Autorenew } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";

function Projects({doRefresh,moreRoutePath,moduleName='DigikalaService'}) {
  const [menu, setMenu] = useState(null);
  const router=useHistory();
  const [syncLogData, setSyncLogData] = useState(false);
  const { columns, rows } = data({data:syncLogData && syncLogData?.results?.length?syncLogData?.results:null});
  const [isLoading, setIsLoading] = useState(false);
  const [searchBody, setSearchBody] = useState({moduleName});
  const [searchQueryParams, setSearchQueryParams] = useState({count:10});
  const [refresh,setRefresh]=useState(false);
  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);
  const changePage=(page)=>{
    setSearchQueryParams((prev)=>{
      return {...
        prev, page:page
      }});
  }
  const getSyncLogData = async () => {
    setIsLoading(true);
    try{
      const result = await axios({
        method: "post",
        url: apiList["sync-log-search"],
        data:searchBody,
        params:searchQueryParams
      });
      if (result && result.data) {
        setSyncLogData(result.data);
      }
    }
    catch (e) {
      console.log('error getting sync log',e.response.data)
    }
    setIsLoading(false);
  };

  // Changing the direction to rtl
  useEffect(() => {
    setSyncLogData({});
    getSyncLogData();
  }, [0,searchBody,searchQueryParams,refresh]);

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      <MenuItem onClick={()=>{
        closeMenu();
        doRefresh();
      }}>رفرش</MenuItem>
      <MenuItem onClick={()=>{
        router.push(moreRoutePath)
      }}>مشاهده نتایج بیشتر</MenuItem>
    </Menu>
  );

  return (
    <Card>
      <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="32px">
        <VuiBox>
          <VuiTypography color="white" variant="lg" mb="6px" gutterBottom>
            تاریخچه همگامسازی - دیجیکالا
          </VuiTypography>
          <VuiBox display="flex" alignItems="center" lineHeight={0}>
            <BsCheckCircleFill color="green" size="15px" />
            <VuiTypography variant="button" fontWeight="regular" color="text" ml="5px">
              &nbsp;<strong>10نتیجه آخر</strong>
            </VuiTypography>
          </VuiBox>
        </VuiBox>
        <VuiBox color="text" px={2}>
          {/*<Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={()=>setRefresh((prev)=>!prev)}>
            more_vert
          </Icon>*/}
          <IconButton sx={{color:'#ffffff',cursor: "pointer", fontWeight: "bold" }} onClick={()=>setRefresh((prev)=>!prev)}>
            <Autorenew/>
          </IconButton>
        </VuiBox>
        {renderMenu}
      </VuiBox>
      <VuiBox
        sx={{
          "& th": {
            borderBottom: ({ borders: { borderWidth, borderColor } }) =>
              `${borderWidth[1]} solid ${borderColor.grey}`,
          },
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                `${borderWidth[1]} solid ${borderColor.grey}`,
            },
          },
        }}
      >
        <Table columns={columns} rows={rows} />
        <Box flex xs={12} sx={{display:'flex',textAlign:'center'}} alignContent={'center'} justifyContent={'center'} alignItems={'center'}>
          <Pagination  color={"primary"} count={syncLogData?.totalResults?Math.ceil(syncLogData?.totalResults/syncLogData?.perPage):10} variant="outlined" onChange={(e,p)=>changePage(p)} />
        </Box>
      </VuiBox>
    </Card>
  );
}

export default Projects;
